import React from 'react'
import SearchWrap from '../../common/components/SearchWrap'
import Content from '../../common/components/Content'
import './index.css'
import Layout from '../Layout'
const Home = () => {
  return (
    <React.Fragment>
      <div className='page-home'>
        <Content />
      </div>
    </React.Fragment>
  )
}
export default Layout(Home, 'home-page')
